






















import {Component, Vue} from 'vue-property-decorator';
import editDialog from './PlanEditPlywoodOrderEditDialog.vue';
import orderCopyDialog from './PlanEditPlywoodOrderCopyOrderDialog.vue';
import CFlexGrid from '@/components/base/flex-grid/CFlexGrid.vue';
import {mapState} from 'vuex';
import PlanEditModel from '@/models/PlanEditModel';

@Component({
    components: {
        CFlexGrid,
        orderCopyDialog,
    },
    computed: {
        ...mapState('planEdit', ['planEdit']),
    },
})
export default class PlanPlywoodOrder extends Vue {
    private editDialog = editDialog;

    public planEdit!: PlanEditModel | null;

    onCopyOrder() {
        (this.$refs.uocd as any).open(
            {},
            {
                saveCallback: async (payload: number[]) => {
                    try {
                        const {data} = await this.$http.post(
                            `${this.$api.journals.planOrder}/CopyOrder`,
                            {ids: payload},
                            {
                                params: {
                                    idPlan: this.$route.params.idPlan,
                                },
                            },
                        );
                        (this.$refs.fg as any).updateData(data);
                        (this.$refs.uocd as any).close();
                    } catch (e) {
                        console.error(e);
                        (this.$refs.uocd as any).close();
                    }
                },
            },
        );
    }
}
